/* eslint-disable */
// import creatHttp from '@/utils/http/creatHttp'
import { otmsHttp } from '@/utils/http/index.js'


// const tmsWebHttp = creatHttp('')

// export  function selectCityAreaTree() {
//   return tmsWebHttp.get('/hope-saas-base-web/bmsCityArea/selectCityAreaTree' )
// }
// export  function selectCityAreaTree2() {
//   return tmsWebHttp.get('/hope-saas-base-web/bmsCityArea/selectCityAreaTree' )
// }

/**
 * 省市区获取
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/15191
 */
 export function getCityAreaTree(data) {
  return otmsHttp.post('/city_area/tree', data);
}
